import { Injectable } from '@angular/core';
import { ApiClass } from "@data/class/api-class";
import { IResponseArray } from "@data/interfaces/iresponseArray.interface";
import { environment } from "@env/environment";
import { catchError, map, Observable, of } from "rxjs";
import { ApplyPreviewResult, CancelPreviewResult, IApplicationList, IApplyPayload, ICancelPayload } from "@modules/private/application/data/interfaces/iapplication.interface";

@Injectable({
  providedIn: 'root'
})
export class ApiApplicationService extends ApiClass {
  constructor() {
    super()
    this.path = 'applications'
  }

  getAll(page = 1, limit = 10, filters = {}) {
    const response: IApplicationList = { error: true, msg: '', data: [], total: 0, status: 200, page: 1, itemsByPage: 10, totalItems: 0 }
    const populate = [
      { path: 'payment', select: ['trackingKey'] },
      { path: 'lease', select: ['folio'] },
      { path: 'appliedBy', select: ['names', '_id'] },
      { path: 'cancelledBy', select: ['names', '_id'] },
    ]

    return this.http.post<IResponseArray>(environment.apiUrl + this.path, { page, limit, filters, populate }).pipe(
      map((r) => {
        if (!r || !r.data.data || r.data.data.length === 0) return response;
        return r as IApplicationList;
      }),
      catchError((e) => of(response))
    )
  }

  /**
   * Previsualiza (dryRun=true) o aplica (dryRun=false) un pago con el MISMO código del backend
   * (F11, F12). El panel siempre previsualiza y siempre manda `stateHash` y `confirmations[]` al
   * aplicar; un 409 significa que el arrendamiento cambió y hay que volver a previsualizar.
   * Sin `user`: quien aplica sale del token (F22).
   */
  createPreview(payload: IApplyPayload, dryRun: boolean): Observable<{ error: boolean, msg: string, data: ApplyPreviewResult | null }> {
    return this.http.post(environment.apiUrl + `applications/create?dryRun=${dryRun}`, payload).pipe(
      map((r) => r as { error: boolean, msg: string, data: ApplyPreviewResult }),
      catchError((e) => of({ error: true, msg: e?.error?.msg || 'No se pudo procesar la aplicación del pago', data: null }))
    )
  }


  getById(id: string) {
    return this.getCollection(id).pipe(
      map((r) => r as { error: boolean, msg: string, data: any })
    )
  }

  /**
   * Cancela una aplicación con motivo y previsualización (F14). Sustituye a la ruta vieja
   * `DELETE :id/cancel/:userId`, que se queda en el backend solo para la app móvil.
   * Requiere `applications.delete` (Administración y, desde F15, Operaciones).
   */
  cancelWithReason(id: string, payload: ICancelPayload, dryRun: boolean): Observable<{ error: boolean, msg: string, data: CancelPreviewResult | null }> {
    return this.http.post(environment.apiUrl + `applications/${id}/cancel?dryRun=${dryRun}`, payload).pipe(
      map((r) => r as { error: boolean, msg: string, data: CancelPreviewResult }),
      catchError((e) => of({ error: true, msg: e?.error?.msg || 'No se pudo procesar la cancelación de la aplicación', data: null }))
    )
  }




  // Nuevo método para obtener arrendamientos específicos de un cliente

  // Nuevo método para obtener información detallada de un arrendamiento específico
}
